import { Component, OnInit } from '@angular/core';

import { ResetPasswordService } from '../services/reset-password.service';
import { ErrorService } from '../../shared/services/error.service';
import { LayoutService } from '../../shared/services/layout.service';

@Component({
    selector: 'login-reset-password',
    templateUrl: 'reset-password.component.html'
})

export class LoginResetPasswordComponent{

    constructor(
        private _resetPasswordService: ResetPasswordService,
        private _errorService: ErrorService,
        private _layoutService: LayoutService
    ) {
        
    }

    ngOnInit() {
    	this._layoutService.setCurrentPage('login-reset-password');
        this._resetPasswordService.resetError();
        this._resetPasswordService.resetResetPasswordData();
    }

    getErrorStatusAndMessage(){
        return this._errorService.getErrorStatusAndMessage();
    }

    getBackEndError(){
        return this._errorService.getBackEndError();
    }

    getResetPasswordData(){
        return this._resetPasswordService.getResetPasswordData();
    }

    getSecurityQuestion(){
        this._resetPasswordService.loadSecurityQuestion();
    }

    isLoadingSecurity(){
        return this._resetPasswordService.isLoadingSecurity();
    }

    isLoading(){
        return this._resetPasswordService.isLoading();
    }

    isDisableSubmit(){
        return this._resetPasswordService.isDisableInputResetPassword();
    }

    resetPassword(){
        this._resetPasswordService.resetPassword();
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/login/components/reset-password.component.ts